module.exports = __webpack_public_path__ + "static/img/1076_small.690975e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1076_small.png
// module id = 31j2
// module chunks = 1